import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import {
  UnavailableHoursSettingsModel,
  UnavailableHoursSettingsUpdateRequest,
} from '@/models/ps-management/availability-hours.model';

export default class UpdateGeoPaymentMethodAvailabilityHoursRequest
  extends ApiResourceMethod<UnavailableHoursSettingsModel> {
  public perform(
    { id, ...restParams }: UnavailableHoursSettingsUpdateRequest,
  ): Promise<UnavailableHoursSettingsModel> {
    return this.performer.requestWithMapper(
      {
        url: `${id}/unavailableHours`,
        data: restParams,
      },
      ({ data }: BaseResponse<UnavailableHoursSettingsModel>): UnavailableHoursSettingsModel => data,
    );
  }
}
